(function () {
  angular.module("akitabox.desktop.floor.organizationList", [
    "akitabox.core.constants",
    "akitabox.core.services.filter",
    "akitabox.core.services.floor",
    "akitabox.ui.dialogs.export",
    "akitabox.desktop.components.filterBarManager",
  ]);
})();
